<template>
  <Dialog :title="null" variant="narrow" @close="emit('close')">
    <p
      v-if="newsletter.paid_subscriptions_status === 'active' && upgradeUrl"
      class="subscription-success-message"
    >
      {{ t("web.subscription.message.subscribed_to") }}
      <strong>{{ newsletter.name }}</strong
      >!
      {{ t("web.subscription.message.support_by_upgrading") }}
    </p>
    <p v-else class="subscription-success-message">
      {{ t("web.subscription.message.subscribed_to") }}
      <strong>{{ newsletter.name }}</strong
      >!
    </p>
    <template #actions>
      <a
        v-if="newsletter.paid_subscriptions_status === 'active' && upgradeUrl"
        :href="upgradeUrl"
        class="subscription-success-button"
      >
        {{ t("web.button.upgrade_subscription") }}
      </a>
      <button
        v-else
        type="button"
        class="subscription-success-button"
        @click="emit('close')"
      >
        Got it
      </button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from "@/design_system/shared/Dialog/Dialog.vue";
import type { Newsletter } from "@/types/newsletter";

import { createTranslator } from "../../lib/utils";

const emit = defineEmits<{
  close: [];
}>();

const props = defineProps<{
  newsletter: Newsletter;
  upgradeUrl: string | null;
}>();

const t = createTranslator(() => props.newsletter.locale);
</script>
